import { useMemo } from 'react';
import { Athlete } from 'oas';
import { useGetAthletes, useGetRelevantTeams } from 'api';

export const useGetRelevantAthletes = (): Athlete[] | undefined => {
    const { data: allAthletes } = useGetAthletes();
    const { data: relevantTeams } = useGetRelevantTeams();

    return useMemo(() => {
        if (!allAthletes || !relevantTeams) {
            return undefined;
        }
        const relevantTeamIds = new Set(relevantTeams.map((team) => team.id));
        return allAthletes.filter((athlete) => relevantTeamIds.has(athlete.current_team_id ?? ''));
    }, [allAthletes, relevantTeams]);
};
